import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import alertify from "alertifyjs";
import useFetchData from "../../hooks/useFetchData";

// bütün verinin çekildiği, filtrelemenin ön yüzde yapıldığı dropdownlarda kullanılabilir.

const CommonDropDownList = ({
  id,
  label,
  valueField,
  textField,
  extraField,
  onChange,
  fetchUrl,
  required,
  disabled,
  filterable = false,
}) => {
  const { data, loading, error } = useFetchData(fetchUrl);
  const [filter, setFilter] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    if (error) {
      alertify.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (filter) {
      const filtered = data.filter((item) => {
        const textMatch = item[valueField]
          .toLowerCase()
          .includes(filter.toLowerCase());
        const extraMatch = extraField
          ? item[extraField].toLowerCase().includes(filter.toLowerCase())
          : false;
        return textMatch || extraMatch;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [filter, data, valueField, extraField]);

  const handleFilterChange = (event) => {
    setFilter(event.filter.value); // Filtre değerini güncelle
  };

  const itemRender = (li, itemProps) => {
    var itemChildren = (
      <li className="k-list-item" style={{ display: "flex" }}>
        <span>{itemProps.dataItem[textField]} </span>
        {extraField && (
          <span style={{ marginLeft: "auto", fontWeight: 700 }}>
            &nbsp; {"(" + itemProps.dataItem[extraField] + ")"}
          </span>
        )}
      </li>
    );

    return React.cloneElement(li, li.props, itemChildren);
  };

  return (
    <DropDownList
      name={id}
      id={id}
      label={label ? label : undefined}
      style={{ width: "100%" }}
      data={filteredData}
      dataItemKey={valueField}
      textField={textField}
      itemRender={itemRender} // Özel öğe render işlevi
      // value={value ? data.find((v) => v[id] === value) : ""}
      onChange={onChange}
      loading={loading}
      required={required}
      disabled={disabled}
      filterable={filterable}
      onFilterChange={handleFilterChange}
    />
  );
};

export default CommonDropDownList;
